import React from "react";
import MoGo from "../assets/projects/MoGo.jpg";
import ActiveBox from "../assets/projects/active-box.jpg";
import { Link } from "react-scroll";
const Work = () => {
  return (
    <div name="work" className=" w-full md:h-screen">
      {/* container */}
      <div className="max-w-[1000px] mx-auto h-screen p-4 flex flex-col justify-center w-full h-full ">
        {/* Title of site chapter */}
        <div className="pb-8">
          <p className="text-4xl font-bold inline-block border-b-4 border-[#008037] ">
            Work
          </p>
          <p className="py-4">// Check out some of my recent work</p>
        </div>
        {/* container for works */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
          {/* work card item */}
          <div
            style={{ backgroundImage: `url(${ActiveBox})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div "
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 gradient flex flex-col w-full h-full justify-center items-center rounded-md duration-150">
              <span className="text-xl font-bold p-2 text-[#0a192f] uppercase block rounded-md   tracking-wider cursor-default ">
                Responsive Website
              </span>

              <div className="pt-8 text-center">
                <a href="#">
                  <button className="text-center rounded-lg px-4 py-2 m-2 hover:text-white hover:bg-[#008037] bg-white text-[#0a192f] font-bold text-lg duration-200">
                    Demo
                  </button>
                </a>
                <a href="#">
                  <button className="text-center rounded-lg px-4 py-2 hover:text-white hover:bg-[#008037] m-2 duration-200 bg-white text-[#0a192f] font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
            {/* //Hover effects */}
          </div>
          <div
            style={{ backgroundImage: `url(${MoGo})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div "
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 gradient flex flex-col w-full h-full justify-center items-center rounded-md duration-150">
              <span className="text-xl font-bold p-2 text-[#0a192f] uppercase block rounded-md   tracking-wider cursor-default ">
                Responsive Website
              </span>

              <div className="pt-8 text-center">
                <a href="#">
                  <button className="text-center rounded-lg px-4 py-2 m-2 hover:text-white hover:bg-[#008037] bg-white text-[#0a192f] font-bold text-lg duration-200">
                    Demo
                  </button>
                </a>
                <a href="#">
                  <button className="text-center rounded-lg px-4 py-2 hover:text-white hover:bg-[#008037] m-2 duration-200 bg-white text-[#0a192f] font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
            {/* //Hover effects */}
          </div>
          <div
            style={{ backgroundImage: `url(${ActiveBox})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div "
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 gradient flex flex-col w-full h-full justify-center items-center rounded-md duration-150">
              <span className="text-xl font-bold p-2 text-[#0a192f] uppercase block rounded-md   tracking-wider cursor-default ">
                Responsive Website
              </span>

              <div className="pt-8 text-center">
                <a href="#">
                  <button className="text-center rounded-lg px-4 py-2 m-2 hover:text-white hover:bg-[#008037] bg-white text-[#0a192f] font-bold text-lg duration-200">
                    Demo
                  </button>
                </a>
                <a href="#">
                  <button className="text-center rounded-lg px-4 py-2 hover:text-white hover:bg-[#008037] m-2 duration-200 bg-white text-[#0a192f] font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
            {/* //Hover effects */}
          </div>
          <div
            style={{ backgroundImage: `url(${MoGo})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div "
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 gradient flex flex-col w-full h-full justify-center items-center rounded-md duration-150">
              <span className="text-xl font-bold p-2 text-[#0a192f] uppercase block rounded-md   tracking-wider cursor-default ">
                Responsive Website
              </span>

              <div className="pt-8 text-center">
                <a href="#">
                  <button className="text-center rounded-lg px-4 py-2 m-2 hover:text-white hover:bg-[#008037] bg-white text-[#0a192f] font-bold text-lg duration-200">
                    Demo
                  </button>
                </a>
                <a href="#">
                  <button className="text-center rounded-lg px-4 py-2 hover:text-white hover:bg-[#008037] m-2 duration-200 bg-white text-[#0a192f] font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
            {/* //Hover effects */}
          </div>
          <div
            style={{ backgroundImage: `url(${ActiveBox})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div "
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 gradient flex flex-col w-full h-full justify-center items-center rounded-md duration-150">
              <span className="text-xl font-bold p-2 text-[#0a192f] uppercase block rounded-md   tracking-wider cursor-default ">
                Responsive Website
              </span>

              <div className="pt-8 text-center">
                <a href="#">
                  <button className="text-center rounded-lg px-4 py-2 m-2 hover:text-white hover:bg-[#008037] bg-white text-[#0a192f] font-bold text-lg duration-200">
                    Demo
                  </button>
                </a>
                <a href="#">
                  <button className="text-center rounded-lg px-4 py-2 hover:text-white hover:bg-[#008037] m-2 duration-200 bg-white text-[#0a192f] font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
            {/* //Hover effects */}
          </div>
          <div
            style={{ backgroundImage: `url(${MoGo})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div "
          >
            {/* Hover effects */}
            <div className="opacity-0 group-hover:opacity-100 gradient flex flex-col w-full h-full justify-center items-center rounded-md duration-150">
              <span className="text-xl font-bold p-2 text-[#0a192f] uppercase block rounded-md   tracking-wider cursor-default ">
                Responsive Website
              </span>

              <div className="pt-8 text-center">
                <a href="#">
                  <button className="text-center rounded-lg px-4 py-2 m-2 hover:text-white hover:bg-[#008037] bg-white text-[#0a192f] font-bold text-lg duration-200">
                    Demo
                  </button>
                </a>
                <a href="#">
                  <button className="text-center rounded-lg px-4 py-2 hover:text-white hover:bg-[#008037] m-2 duration-200 bg-white text-[#0a192f] font-bold text-lg">
                    Code
                  </button>
                </a>
              </div>
            </div>
            {/* //Hover effects */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Work;
